import type { NewsletterSignupComponent } from "../../types";

/**
 * Newsletter signup band — dark premium (carbon surface + top edge glow), on-brand
 * green/amber accents. White Space Grotesk title, glassy input with a green focus
 * ring, amber pill submit that lifts on hover.
 */
export function NewsletterSignupRenderer({ component }: { component: NewsletterSignupComponent }) {
  const { title, description, consentLabel, emailPlaceholder, requiredNote, submitLabel } = component.content;

  return (
    <section className="apa-surface-dark apa-edge-glow-top mx-[calc(50%-50vw)] mt-16 -mb-16 pb-10 pt-10 text-white md:-mb-16">
      <div className="mx-auto w-full max-w-4xl px-6 md:px-8">
        <div className="space-y-4 rounded-xl p-5 md:p-8">
          <div>
            <p className="text-2xl font-bold tracking-tight leading-snug" style={{ fontFamily: "var(--font-aleo)" }}>
              {title}
            </p>
            {description ? <p className="mt-2 text-sm text-white/70 md:text-base">{description}</p> : null}
          </div>
          <label className="flex items-start gap-2 text-sm text-white/80 xl:text-base">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4 rounded bg-transparent accent-[#00B862]"
            />
            <span>{consentLabel}</span>
          </label>
          <div className="space-y-1">
            <input
              type="email"
              className="h-12 w-full rounded-lg bg-white/10 px-4 text-base text-white placeholder-white/50 ring-1 ring-white/15 transition focus:outline-none focus:ring-2 focus:ring-[#00B862] focus:shadow-[0_0_0_4px_rgba(0,184,98,.15)] xl:text-lg"
              placeholder={emailPlaceholder}
            />
            {requiredNote ? <p className="text-xs text-white/55 xl:text-sm">{requiredNote}</p> : null}
          </div>
          <button className="inline-flex items-center gap-2 rounded-full bg-[#FFC105] px-6 py-2.5 text-sm font-bold text-[#0A0A0A] shadow-[var(--shadow-e1)] transition hover:-translate-y-0.5 hover:shadow-[var(--shadow-glow)] xl:text-base">
            {submitLabel}
            <span aria-hidden="true">›</span>
          </button>
        </div>
      </div>
    </section>
  );
}
